module.exports = __webpack_public_path__ + "media/images/ogp-af9d798c85fb8fc450a60263b4d904c6.png";